<template>
    <div>
        <!-- <div v-for="(list, index) in statusType" :key="index"> -->
        <span class="alerts-actions-views" :class="statusClass">
            <i :class="statusIcon"></i>
        </span>
        <!-- </div> -->
    </div>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        statusType: {
            type: String,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        statusIcon() {
            if (this.statusType == 'mis_matched') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType == 'expired') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType == 'expiredIn') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType == 'pep') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType == 'enforcement') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType == 'blackList') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType == 'sanction') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType == 'high') {
                return 'icon-cross-with-circle'
            }
            if (this.statusType == 'periodic_review_due') {
                return 'icon-cross-with-circle'
            }
            return 'icon-tick-with-circle'
        },
        statusClass() {
            if (this.statusType == 'mis_matched') {
                return 'black'
            }
            if (this.statusType == 'expired') {
                return 'danger'
            }
            if (this.statusType == 'expiredIn') {
                return 'danger'
            }
            if (this.statusType == 'pep') {
                return 'black'
            }
            if (this.statusType == 'enforcement') {
                return 'black'
            }
            if (this.statusType == 'blackList') {
                return 'black'
            }
            if (this.statusType == 'sanction') {
                return 'black'
            }
            if (this.statusType == 'high') {
                return 'black'
            }
            if (this.statusType == 'medium') {
                return 'danger'
            }
            if (this.statusType == 'periodic_review_due') {
                return 'danger'
            }

            return 'low'
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
